import React from "react";
import { useForm, validators } from "@hooks";
import classNames from "classnames";
import { ExclamationCircleIcon } from "@heroicons/react/24/solid";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { helpers, Constants } from "@shared";

const Login = ({ submit, initial, children }) => {

    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    const initialState = { email: ``, password: ``, ...initial };

    const validations = {
        email: (val) => validators.isValidEmail(val) || { email: `Email is not valid` },
        password: (val) => validators.hasValue(val) || { password: `Password is required` }
    };

    const { values, errors, changeHandler, submitHandler } = useForm(initialState, {}, validations, submit);

    const reset = () => {
        helpers.navigateStart(location, navigate, Constants.Flows.sendPasswordReset.id, undefined, { email: values.email }, params);
    };

    return (
        <>
            {children}
            <form method="POST" className="w-11/12" onSubmit={submitHandler} >
                <div className="flex flex-col bg-sb-frame rounded-lg border-2 shadow-md  p-5 space-y-3">
                    <div>
                        <label htmlFor="email" className="font-semibold text-gray-700">Email</label>
                        <div className="relative mt-1 rounded-md shadow-sm">
                            <input type="text" name="email" id="email" className={classNames(`block w-full rounded-md shadow-md focus:outline-none text-gray-600`, { "input-error": errors.email })} value={values.email} onChange={changeHandler} aria-invalid="true" aria-describedby="email-error" />
                            {
                                errors.email &&
                                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                                    <ExclamationCircleIcon className="fill-red-500 h-6" />
                                </div>
                            }
                        </div>
                        {
                            errors.email &&
                            <p className="mt-2 text-sm text-red-600" id="email-error">{errors.email}</p>
                        }
                    </div>
                    <div>
                        <label htmlFor="password" className="font-semibold text-gray-700">Password</label>
                        <div className="relative mt-1 rounded-md shadow-sm">
                            <input type="password" name="password" id="password" className={classNames(`block w-full rounded-md shadow-md focus:outline-none text-gray-600`, { "input-error": errors.password })} value={values.password} onChange={changeHandler} aria-invalid="true" aria-describedby="email-error" />
                            {
                                errors.password &&
                                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                                    <ExclamationCircleIcon className="fill-red-500 h-6" />
                                </div>
                            }
                        </div>
                        {
                            errors.password &&
                            <p className="mt-2 text-sm text-red-600" id="email-error">{errors.password}</p>
                        }
                    </div>
                    <div>
                        < button
                            className="background-transparent underline px-3 py-1 text-lg outline-none focus:outline-none mr-1 mb-1"
                            type="button"
                            onClick={reset}>
                            Forgot your password?
                        </button>
                    </div>
                </div>
                <button type="submit" className="btn btn-primary h-14 mt-7 text-lg font-bold rounded-full">Login</button>
            </form>
        </>
    );
};

Login.propTypes = {
    submit: PropTypes.func.isRequired,
    initial: PropTypes.object,
    children: PropTypes.element.isRequired
};

export default Login;